// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__dLlvJ","notes":"Notes_notes__E3PHE","note":"Notes_note__Alx0g","markdown":"Notes_markdown__2wKZg"};